module.exports = __webpack_public_path__ + "img/home-perfect-2.caaa5b15.png";